import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface IBigBookmarkOutlinedIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const BigBookmarkOutlinedIcon = ({
  width = styleConfigs.dimensions.width24,
  height = styleConfigs.dimensions.height24,
  color = COLORS.mistBlue,
  ...props
}: IBigBookmarkOutlinedIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_big_bookmark)">
      <path
        d="M3.42871 2.78453V22.9266L11.9998 16.9269L20.5709 22.9266V2.78453C20.5709 1.8378 19.8035 1.07031 18.8567 1.07031H5.14293C4.1962 1.07031 3.42871 1.8378 3.42871 2.78453Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_big_bookmark">
        <rect width="23.9991" height="23.9991" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BigBookmarkOutlinedIcon;
